import React, { ButtonHTMLAttributes } from 'react'
import { Spinner } from 'react-bootstrap'
import styled from 'styled-components'
import styles from '../../utility/styles'

const colors = {
	primary: styles.colors.blue,
	secondary: styles.colors.mediumGray,
	success: styles.colors.green,
	disabled: 'var(--tz-hairline, rgba(255, 255, 255, 0.08))',
	secondary_alt: styles.colors.background,
	error: styles.colors.error,
	alert: styles.colors.alert,
}

const DefaultButton = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 10px 18px;
	box-shadow: none;
	background-color: ${({ variant }) => colors[variant]};
	border: none;
	border-radius: 10px;
	text-decoration: none !important;
	touch-action: manipulation;
	transition: filter 0.15s, background-color 0.15s;
	&:hover:not(:disabled) {
		filter: brightness(1.08);
	}
	&:focus-visible {
		outline: 2px solid rgba(16, 171, 255, 0.6);
		outline-offset: 2px;
	}
	&:disabled {
		color: ${styles.colors.mediumGray};
	}
	@media (prefers-reduced-motion: reduce) {
		transition: none;
	}
	font-family: ${styles.fonts.geist};
	font-weight: 500;
	color: ${({ color, disabled }) =>
		typeof color === 'string'
		? color
			: styles.colors.white};
`

/**
 *
 * @param {{variant:'primary'|'secondary', spinnerVariant?:string, loading?:boolean, success?:boolean, as?:string, hideShadow?:boolean}&ButtonHTMLAttributes} props
 */
export default function Button({
	variant = 'primary',
	children,
	loading,
	success,
	disabled,
	hideShadow = false,
	spinnerVariant,
	pill = false,
	...props
}) {
	return (
		<DefaultButton
			variant={success ? 'success' : disabled ? 'disabled' : variant}
			{...{ disabled, hideShadow, pill }}
			{...props}
		>
			{loading ? (
				<Spinner
					as='span'
					animation='border'
					variant={spinnerVariant ? spinnerVariant : variant}
					role='status'
					aria-hidden='true'
				/>
			) : (
				<React.Fragment>{children}</React.Fragment>
			)}
		</DefaultButton>
	)
}
